export default [
  {
    title: 'E-stamp',
    customIcon: 'EstampSvg',
    children: [
      {
        title: "E-stamp List",
        route: "custom-e-stamp-list",
        path: "/custom-e-stamp/list",
      },
      {
        title: "Icon E-stamp",
        route: "custom-e-stamp-icon",
        path: "/custom-e-stamp-icon/list",
      },
      {
        title: "Template E-stamp",
        route: "custom-e-stamp-template",
        path: "/custom-e-stamp-template/list",
      },
    ]
  },
];